/**
 * Sweep S49. The day a week after an instant, in the organisation's own zone,
 * as a value a `date` input accepts — the default for "Copy this event".
 *
 * THE DAY IS READ IN THE ORGANISATION'S ZONE, NOT THE VIEWER'S. A 23:30 kick-off
 * in Budapest is already the next day in UTC, and a default read in the wrong
 * zone offers the copy a day late. The server moves the event by whole days in
 * that same zone, so the two agree.
 */
export function dayAWeekAfter(iso: string, zone: string | null): string {
  // sv-SE writes YYYY-MM-DD, the one shape a date input takes.
  const day = new Date(iso).toLocaleDateString("sv-SE", zone ? { timeZone: zone } : {});
  const next = new Date(`${day}T00:00:00Z`);
  next.setUTCDate(next.getUTCDate() + 7);
  return next.toISOString().slice(0, 10);
}
